import { Grid, Typography } from "@mui/material";
import FormField from "../../../../../components/common/FormField";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { leadCustomerNotesFields } from "../../../lead/leadAllFields";
import { setNewStorageLocal } from "../../../../../store/reducers/storageSlice";

interface ManageCustomerNotesFormProps {
  checkValidator?: any;
  resetValidator?: any;
  error?: any;
  formData?: any;
  setFormData?: any;
}

const CustomerNotesForm: FC<ManageCustomerNotesFormProps> = ({
  checkValidator,
  resetValidator,
  error,
  formData,
  setFormData,
}) => {
  const dispatch = useDispatch();

  const { newStorageLocal } = useSelector((state: any) => state.storage);
  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    dispatch(
      setNewStorageLocal({
        ...newStorageLocal,
        [id]: value,
      }),
    );
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));

    resetValidator(event.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        spacing={0.5}
        rowGap={0}
        rowSpacing={0}
        sx={{
          background: "#E5F4F1",
          padding: "10px !important",
          marginTop: "10px !important",
          borderRadius: "5px",
          border: "1px solid #CFCFCF",
          overflow: "hidden",
        }}
      >
        <Grid item xs={12} sm={12} style={{ padding: 0 }}>
          <Typography
            align="left"
            sx={{
              textAlign: "left",
              padding: "0px",
              fontWeight: 600,
              color: "#333333",
            }}
            variant="subtitle1"
          >
            Customer Notes
          </Typography>
        </Grid>
        {leadCustomerNotesFields?.map((field, i) => {
          return (
            <FormField
              // onPaste={(e: any) => e.preventDefault()}
              {...{
                ...field,
                multiline: true,
                value: newStorageLocal ? newStorageLocal[field?.id] : "",
                ...{
                  variant: "outlined", // Adding this variant prop
                  onChange: onChangeAction,
                  onBlur: onBlurAction,
                  isNonMarginTop: true,
                  InputProps: {
                    sx:
                      field?.type === "text" || field?.type === "password"
                        ? { height: "auto" }
                        : { padding: "10px 4px", height: "36px" },
                  },
                },
                error: error && error[field?.id],
              }}
            />
          );
        })}
      </Grid>
    </>
  );
};
export default CustomerNotesForm;
